import { FC } from "react";
import { clsxMerge } from "shared/lib/helpers/styles";

export const CallCopilotMessageContainer: FC<{
  children?: React.ReactNode;
  isConnected?: boolean;
}> = ({ children, isConnected }) => {
  return (
    <div
      className={clsxMerge(
        "relative mb-5 animate-fadein",
        "border border-[#C930AD]",
        "rounded-md px-4 pb-2 pr-2 pt-5"
      )}
    >
      {isConnected && (
        <div
          className={clsxMerge(
            "absolute left-2 top-[-21px] h-[21px] w-[2px]",
            "bg-gradient-to-b from-[#4B61AB] to-[#CC3997]"
          )}
        />
      )}
      {children}
    </div>
  );
};
